export type EditorList = EditorListDetails[];
export interface IEditorListDetails {
    content: string;
    editorId: string;
    static_template_pages_id: any;
}

export class EditorListDetails implements IEditorListDetails {
    content: string;
    editorId: string;
    static_template_pages_id: any;
    constructor(content: string, editorId: string, static_template_pages_id?) {
        this.content = content;
        this.editorId = editorId;
        this.static_template_pages_id = static_template_pages_id
    }
}